import React from "react"
import Echart from "echarts-for-react"
import { statsStore } from "../../stats-store"
import { langStore } from "@/stores/lang-store"
import { boxplotHorizontalStore } from "./boxplot-horizontal-store"
import { summaryStore } from "../summary/summary-store"
import { boxplotBundle } from "./boxplot-const"

const BoxplotHorizontal = ({ title = "수도 사용량 분포", className = "", axisMax }) => {
  const { unit } = statsStore()

  const { lang } = langStore()

  const { boxplotSeries, scatterSeries, color } = boxplotHorizontalStore()
  const { selectedKey } = summaryStore()
  const xAxisData = selectedKey === "ALL" ? boxplotBundle.all[lang] : selectedKey

  const series = [scatterSeries, boxplotSeries]
  const option = {
    grid: {
      top: 80,
      left: 40,
      right: 20,
      bottom: 30
    },
    title: { text: title },
    tooltip: {
      trigger: "item",
      borderColor: color,
      formatter: (p) => {
        if (p.seriesType === "custom") {
          const [min, q1, med, q3, max] = p.data
          const t = boxplotBundle.stats

          return `
            <div style="padding:0px 8px;">
              <b>${p.name} ${t.title[lang]}</b>(${unit})<br/>
              ${t.max[lang]}: ${max}<br/>
              ${t.q3[lang]}: ${q3}<br/>
              ${t.median[lang]}: ${med}<br/>
              ${t.q1[lang]}: ${q1}<br/>
              ${t.min[lang]}: ${min}
            </div>
          `
        }

        if (p.seriesType === "scatter") {
          return `
            ${p.name} ${boxplotBundle.stats.outlier[lang]}<br/>
            ${p.data[2]}: <b>${p.data[0]}</b> ${unit}
          `
        }

        return ""
      }
    },
    // INFO: 가로형이므로 값이 X축으로 들어감
    xAxis: {
      type: "value",
      max: axisMax,
      name: unit,
      splitLine: { lineStyle: { type: "dashed" } }
    },
    // INFO: 가로형이므로 카테고리가 Y축으로 들어감
    yAxis: {
      type: "category",
      data: [xAxisData],
      axisLabel: { rotate: 90, hideOverlap: true }
    },
    series
  }

  return (
    <section className={`${className}`}>
      <Echart
        style={{
          width: "100%",
          height: "100%"
        }}
        option={option}
        notMerge
        autoResize
      />
    </section>
  )
}

export default BoxplotHorizontal
